import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { NewAccountPage } from '../pages/new-account/new-account';
import { ScannerPage } from '../pages/scanner/scanner';
import { CustomersPage } from '../pages/customers/customers';
import { LoginPage } from '../pages/login/login';
import { AdminTabsPage } from '../pages/admin-tabs/admin-tabs';
import { PricingPage } from '../pages/pricing/pricing';

import { AuthenticationApi } from '../services/authentication/authentication-api';

@Component({
  templateUrl: 'app.html'
})
export class AtlasApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;
  activePage: any;

  sysAdminPages: Array<{title: string, component: any}>;
  adminPages: Array<{title: string, component: any}>;
  staffPages: Array<{title: string, component: any}>;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, private menuCtrl: MenuController, private authApi: AuthenticationApi) {
    this.initializeApp();

    this.sysAdminPages = [
      { title: 'Scanner', component: ScannerPage },
      { title: 'New Account', component: NewAccountPage },
      { title: 'Pricing', component: PricingPage },
      { title: 'Customers', component: CustomersPage },
      { title: 'Admin', component: AdminTabsPage },
      { title: 'Logout', component: null },
    ];

    this.adminPages = [
      { title: 'Scanner', component: ScannerPage },
      { title: 'New Account', component: NewAccountPage },
      { title: 'Pricing', component: PricingPage },
      { title: 'Customers', component: CustomersPage },
      { title: 'Admin', component: AdminTabsPage },
      { title: 'Logout', component: null },
    ];

    this.staffPages = [
      { title: 'Scanner', component: ScannerPage },
      { title: 'New Account', component: NewAccountPage },
      { title: 'Pricing', component: PricingPage },
      { title: 'Customers', component: CustomersPage },
      { title: 'Logout', component: null },
    ];

    this.activePage = this.staffPages[0];
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      // Determine which menu is active.
      let self: AtlasApp = this;
      let menuId: Array<string>|string = this.menuCtrl.getMenus().filter(function(m){ return self.menuCtrl.isEnabled(m.id); })[0].id;
      menuId = menuId.split("-");
      menuId = menuId.map(function(m){ return m.charAt(0).toUpperCase() + m.substr(1).toLowerCase() })
      menuId = menuId.join("");
      menuId = menuId.charAt(0).toLowerCase() + menuId.substr(1);

      // Update the nav view active item.
      this.nav.viewDidLoad.subscribe(e => this.activePage = this[`${menuId}Pages`].filter(function(p){ return e.component == p.component; })[0]);
    });
  }

  openPage(page) {
    if( page.component ) {
      this.nav.setRoot(page.component);
    }
    else {
      this.authApi.logout().subscribe(
        () => {},
        () => {},
        () => {this.nav.setRoot(LoginPage);}
      );
    }
  }

  checkActive(page) {
    return page == this.activePage;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts